import { FC, SVGProps } from 'react';

export const ArrowIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5006 4.30804C16.8618 4.66927 16.8618 5.25495 16.5006 5.61618L10.1168 11.9999L16.5006 18.3834C16.8618 18.7447 16.8618 19.3303 16.5006 19.6916C16.1393 20.0528 15.5536 20.0528 15.1924 19.6916L7.50051 11.9999L15.1924 4.30804C15.5536 3.9468 16.1393 3.9468 16.5006 4.30804Z"
        fill="#14151A"
      />
      <rect x="9" y="11" width="15" height="2" rx="1" fill="#141519" />
    </svg>
  );
};
